import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import ActivationModal from '../components/ActivationModal';

const ActivationContext = createContext(null);

export const useActivation = () => {
  const ctx = useContext(ActivationContext);
  if (!ctx) return { open: () => {}, close: () => {} };
  return ctx;
};

export function ActivationProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState(null);

  const openModal = useCallback((r) => {
    setReason(r || null);
    setOpen(true);
  }, []);
  const close = useCallback(() => setOpen(false), []);

  // Global axios interceptor : any 402 with code=ACTIVATION_REQUIRED pops the modal.
  // Also listen to a CustomEvent so other providers (UpgradeContext) can
  // re-route candidate-tier upsells to this modal instead of 290€.
  useEffect(() => {
    const id = axios.interceptors.response.use(
      (r) => r,
      (error) => {
        try {
          const status = error?.response?.status;
          const detail = error?.response?.data?.detail;
          const code = typeof detail === 'object' ? detail?.code : null;
          if (status === 402 && code === 'ACTIVATION_REQUIRED') {
            openModal(detail?.message || "Action réservée aux établissements activés.");
          }
        } catch (e) { /* noop */ }
        return Promise.reject(error);
      },
    );
    const evHandler = (e) => openModal(e?.detail?.reason || null);
    window.addEventListener('open-activation-modal', evHandler);
    return () => {
      axios.interceptors.response.eject(id);
      window.removeEventListener('open-activation-modal', evHandler);
    };
  }, [openModal]);

  return (
    <ActivationContext.Provider value={{ open: openModal, close }}>
      {children}
      <ActivationModal open={open} onClose={close} reason={reason} />
    </ActivationContext.Provider>
  );
}
